export const GCHAT_SET_USER = 'GCHAT_SET_USER';
export const GCHAT_RESET = 'GCHAT_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
